import url from '../../utils/url';
import { FETCH_DATA, POST_DATA } from '../middlewares/api';
import { schema } from './entities/orgChart';
import { combineReducers } from 'redux';

/***********************************************************************************************************************
 * 													CONSTANTS 														                                                     *
 * *********************************************************************************************************************/
export const types = {
	FETCH_ORGCHART_REQUEST: 'ORGCHART_TAB/FETCH_ORGCHART_REQUEST',
	FETCH_ORGCHART_SUCCESS: 'ORGCHART_TAB/FETCH_ORGCHART_SUCCESS',
	FETCH_ORGCHART_FAILURE: 'ORGCHART_TAB/FETCH_ORGCHART_FAILURE',

	POST_FOLLOW_REQUEST: 'ORGCHART_TAB/POST_FOLLOW_REQUEST',
	POST_FOLLOW_SUCCESS: 'ORGCHART_TAB/POST_FOLLOW_SUCCESS',
	POST_FOLLOW_FAILURE: 'ORGCHART_TAB/POST_FOLLOW_FAILURE'
};

/***********************************************************************************************************************
 * 													STATE   														                                                       *
 * *********************************************************************************************************************/
const initialState = {
	orgchart: {
		isFetching: false,
		isPosting: false,
		followStatus: 100,
		id: null
	}
};

/***********************************************************************************************************************
 * 													ACTIONS 														   *
 * *********************************************************************************************************************/
export const actions = {
	loadOrgChartTab: (id) => {
		console.log(id);
		return (dispatch, getState) => {
			const endpoint = url.getOrgChart(id);
			const temp = fetchOrgChartTab(endpoint, id);
			return dispatch(temp);
		};
	},
	followDepartment: (data) => {
		return (dispatch, getState) => {
			const endpoint = url.postFollowDepartment();
			return dispatch(postFollowDepartment(endpoint, data));
		};
	}
};

const fetchOrgChartTab = (endpoint, id) => ({
	[FETCH_DATA]: {
		types: [
			types.FETCH_ORGCHART_REQUEST,
			types.FETCH_ORGCHART_SUCCESS,
			types.FETCH_ORGCHART_FAILURE
		],
		endpoint,
		schema
	},
	id
});

const postFollowDepartment = (endpoint, data) => ({
	[POST_DATA]: {
		types: [types.POST_FOLLOW_REQUEST, types.POST_FOLLOW_SUCCESS, types.POST_FOLLOW_FAILURE],
		endpoint,
		schema,
		data
	}
});

/***********************************************************************************************************************
 * 													REDUCERS 														   *
 * *********************************************************************************************************************/
const orgChart = (state = initialState.orgchart, action) => {
	switch (action.type) {
		case types.FETCH_ORGCHART_REQUEST:
			return { ...state, isFetching: true };
		case types.FETCH_ORGCHART_SUCCESS:
			return { ...state, isFetching: false, id: action.response.ids };
		case types.FETCH_ORGCHART_FAILURE:
			return { ...state, isFetching: false };
		case types.POST_FOLLOW_REQUEST:
			return { ...state, isPosting: true, followStatus: 100 };
		case types.POST_FOLLOW_SUCCESS:
		case types.POST_FOLLOW_FAILURE:
			return { ...state, isPosting: false, followStatus: action.response.status };
		default:
			return state;
	}
};

const reducer = combineReducers({ orgChart });
export default reducer;

/***********************************************************************************************************************
 * 													SELECTORS 														                                                     *
 * *********************************************************************************************************************/

export const getOrgChart = (state) => {
	return state.entities.orgChart;
};

export const getFollowStatus = (state) => {
	return state.orgChartTab.orgChart.followStatus;
};

export const getTopLeader = (state) => {
	for (const [key, value] of Object.entries(state.entities.orgChart)) {
		if (value.level === 'c-0' && state.orgChartTab.orgChart.id.includes(value.id)) {
			return [
				{
					data: value,
					active: true,
					hasBelong: true
				}
			];
		}
	}
};

export const getLevel = (state, id, levelStringNumber) => {
	let level = [];
	console.log('levelStringNumber: ', levelStringNumber);
	for (const [key, value] of Object.entries(state.entities.orgChart)) {
		let hasBelong = false;
		const getValue = value;
		for (const [key, value] of Object.entries(state.entities.orgChart)) {
			if (value.belongsTo === getValue.id) hasBelong = true;
		}
		if (value.belongsTo === id && value.level === levelStringNumber) {
			level.push({
				data: value,
				active: true,
				hasBelong
			});
		}
	}
	return level;
};

export const subscribeOrgChart = (state, id) => {
	console.log('subscribeOrgChart : ', id);
	state.entities.orgChart[id].subscribed = true;
	// console.log(  state.entities.orgChart)
	return state.entities.orgChart;
};
